module.exports = __webpack_public_path__ + "static/media/4.dcf9e0cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hairfront/4.png
// module id = 699
// module chunks = 0